/**
 * @name header
 *
 * @description
 * Constants about the header.
 *
 * @remarks
 * We are using a fallback for the banner size because we have to decrease CLS as best as possible.
 */
import type {Breakpoint} from '_uiComponents'

/**
 * Fallback for banner size.
 */
const BANNER_SIZE = {
    base: 55,
    sm: 38,
    xl: 53,
}

/**
 * Fallback for usableNet banner size.
 */
export const ACCESSIBILITY_BANNER_SIZE = {
    base: 34,
    sm: 34,
    md: 34,
    lg: 34,
    xl: 34,
    '2xl': 34,
}

/**
 * Contains both collapsed and not collapsed values for breakpoints.
 */
const HEADER_SIZE_WITHOUT_BANNER: {not_collapsed: Record<Breakpoint, number>; collapsed: Record<Breakpoint, number>} = {
    not_collapsed: {
        base: 81,
        sm: 81,
        md: 81,
        lg: 142,
        xl: 142,
        '2xl': 142,
    },
    collapsed: {
        base: 52,
        sm: 52,
        md: 52,
        lg: 78,
        xl: 46,
        '2xl': 46,
    },
}

export const HEADER_SIZE_NOT_COLLAPSED_WITHOUT_BANNER: Record<Breakpoint, number> = {...HEADER_SIZE_WITHOUT_BANNER.not_collapsed}

export const HEADER_SIZE_COLLAPSED_WITHOUT_BANNER: Record<Breakpoint, number> = {...HEADER_SIZE_WITHOUT_BANNER.collapsed}

export const HEADER_SIZE_NOT_COLLAPSED_WITH_BANNER: Record<Breakpoint, number> = {
    base: HEADER_SIZE_WITHOUT_BANNER.not_collapsed.base + BANNER_SIZE.base,
    sm: HEADER_SIZE_WITHOUT_BANNER.not_collapsed.sm + BANNER_SIZE.sm,
    md: HEADER_SIZE_WITHOUT_BANNER.not_collapsed.md + BANNER_SIZE.sm,
    lg: HEADER_SIZE_WITHOUT_BANNER.not_collapsed.lg + BANNER_SIZE.sm,
    xl: HEADER_SIZE_WITHOUT_BANNER.not_collapsed.xl + BANNER_SIZE.xl,
    '2xl': HEADER_SIZE_WITHOUT_BANNER.not_collapsed['2xl'] + BANNER_SIZE.xl,
}

export const HEADER_SIZE_COLLAPSED_WITH_BANNER: Record<Breakpoint, number> = {
    base: HEADER_SIZE_WITHOUT_BANNER.collapsed.base + BANNER_SIZE.base,
    sm: HEADER_SIZE_WITHOUT_BANNER.collapsed.sm + BANNER_SIZE.sm,
    md: HEADER_SIZE_WITHOUT_BANNER.collapsed.md + BANNER_SIZE.sm,
    lg: HEADER_SIZE_WITHOUT_BANNER.collapsed.lg + BANNER_SIZE.sm,
    xl: HEADER_SIZE_WITHOUT_BANNER.collapsed.xl + BANNER_SIZE.xl,
    '2xl': HEADER_SIZE_WITHOUT_BANNER.collapsed['2xl'] + BANNER_SIZE.xl,
}

export function addAccessibilityBannerHeight(headerSize: Record<Breakpoint, number>): Record<Breakpoint, number> {
    return {
        base: headerSize.base + ACCESSIBILITY_BANNER_SIZE.base,
        sm: headerSize.sm + ACCESSIBILITY_BANNER_SIZE.sm,
        md: headerSize.md + ACCESSIBILITY_BANNER_SIZE.md,
        lg: headerSize.lg + ACCESSIBILITY_BANNER_SIZE.lg,
        xl: headerSize.xl + ACCESSIBILITY_BANNER_SIZE.xl,
        '2xl': headerSize['2xl'] + ACCESSIBILITY_BANNER_SIZE['2xl'],
    }
}
